module.exports = __webpack_public_path__ + "img/icon-facebook.d9bf88c4.svg";